// RowActionsMenu.jsx
import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PropTypes from "prop-types";
const RowUserActionsMenu = ({ row, onUserEdit, onUserDelete, hasPermission }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const isInactive = row.is_user_active == 0;
  return (
    <>
      <IconButton onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {!hasPermission("edit") && (
          <MenuItem
            onClick={() => {
              onUserEdit(row);
              handleClose();
            }}
          >
            Edit User
          </MenuItem>
        )}
        {!hasPermission("delete") && (
          <MenuItem
            disabled={isInactive}
            onClick={() => {
              onUserDelete(row.college_id);
              handleClose();
            }}
          >
            Delete User
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
RowUserActionsMenu.propTypes = {
  row: PropTypes.shape({
    client_id: PropTypes.number.isRequired,
    society_id: PropTypes.number.isRequired,
    college_id: PropTypes.number.isRequired,
    user_id: PropTypes.number.isRequired,
    user_name: PropTypes.string.isRequired,
    is_user_active: PropTypes.number.isRequired,
    db_instance_id: PropTypes.number.isRequired,
  }).isRequired,
  onUserEdit: PropTypes.func.isRequired,
  onUserDelete: PropTypes.func.isRequired,
  hasPermission: PropTypes.func.isRequired,
};
export default RowUserActionsMenu;
